import React from 'react';
import { MessageCircleIcon, PaletteIcon, SmartphoneIcon } from 'lucide-react';
import { Reveal } from './Reveal';
interface ValueStripProps {
  onMobilePreview?: () => void;
}
const values = [{
  icon: PaletteIcon,
  title: 'Diseño personalizado',
  description: 'Una dirección visual que habla de tu marca.'
}, {
  icon: SmartphoneIcon,
  title: 'Lista para celular',
  description: 'Pensada para la pantalla donde te encuentran.'
}, {
  icon: MessageCircleIcon,
  title: 'WhatsApp directo',
  description: 'Del interés a la conversación, sin vueltas.'
}];
export function ValueStrip({
  onMobilePreview
}: ValueStripProps) {
  return <section className="w-full bg-coral py-14 text-white sm:py-16" data-id="element-160" data-mp="37ojd9isacbxa">
      <div className="mx-auto grid max-w-7xl gap-7 px-5 sm:px-8 md:grid-cols-3" data-id="element-161" data-mp="3cmun3tikymfi">
        {values.map((value, index) => {
        const Icon = value.icon;
        return <Reveal key={value.title} delay={index * 0.08} data-id="element-162" data-mp="1i8a9g0sofr5m" data-mpi={index}>
              <div className="flex items-start gap-4" data-id="element-163" data-mp="1i8tn35bantdu">
                {index === 1 && onMobilePreview ? <button type="button" onClick={onMobilePreview} className="flex h-12 w-12 shrink-0 items-center justify-center border-2 border-white bg-ink transition-colors hover:bg-brand-500 focus:outline-none focus-visible:ring-4 focus-visible:ring-lime" aria-label="Ver la página en vista móvil" title="Ver vista móvil" data-id="element-164" data-mp="pg4bnl39gkrl">
                    <Icon className="h-5 w-5" data-id="element-165" data-mp="13daokz1azp8w" />
                  </button> : <span className="flex h-12 w-12 shrink-0 items-center justify-center border-2 border-white bg-ink" data-id="element-166" data-mp="ye6hqf1uq3lq">
                    <Icon className="h-5 w-5" data-id="element-167" data-mp="uc2vqwhk3gm7" />
                  </span>}
                <div data-id="element-168" data-mp="3j56zkpo6et4h">
                  <h2 className="font-display text-2xl font-extrabold leading-none" data-id="element-169" data-mp="3j5qavnjbmj9j">{value.title}</h2>
                  <p className="mt-2 text-sm font-semibold leading-relaxed text-white/85" data-id="element-170" data-mp="3f1s892useqbq">{value.description}</p>
                </div>
              </div>
            </Reveal>;
      })}
      </div>
    </section>;
}